var map = {
	"./csharp.js": "iQFD",
	"./golang.js": "M62i",
	"./html.js": "+fEh",
	"./java.js": "GVhv",
	"./nodejs.js": "iyZf",
	"./php.js": "TTBR",
	"./python.js": "4a2j",
	"./shell.js": "Eo63"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "SSzV";


//////////////////
// WEBPACK FOOTER
// ./src/utils/codeWs/cswap ^\.\/.*\.js$
// module id = SSzV
// module chunks = 3